/** @jsx jsx */
import React from "react"
import { jsx, Container, Flex, Box, Text } from "theme-ui"
import { GatsbyImage } from "gatsby-plugin-image"
import { useFooterNavElements } from "../hooks/useFooterNavElements"
import Link from "./shared/Link"
import Action from "./shared/Action"

const FooterNavGroup = ({ navGroup }) => {
  const { links } = navGroup
  return (
    <Flex sx={{ variant: "footerNavListWrapper" }}>
      <Flex
        sx={{
          variant: "footerNavList",
          flexDirection: navGroup?.footerNavGroupTitle === "Check Us Out" ? "row" : "column",
          alignItems: "baseline",
          fontFamily: "fonts.body !important",
        }}
        className="footer_padding"
      >
        {links?.map((link) => (
          <Box key={link.id} sx={{ padding: "5px 0" }}>
            <Action
              icon={link?.icon}
              url={link.url}
              iconSize={link?.iconSize}
              style={link?.style}
              actionEvent={link?.actionEvent}
              label={link?.label}
              footer={true}
              fontsize="14px"
              classnameForAnalytics={link.classnameForAnalytics}
            />
          </Box>
        ))}
      </Flex>
    </Flex>
  )
}

const Footer = () => {
  const data = useFooterNavElements()
  const { footerNavGroups, footerNavLogo } = data
  const year = new Date().getFullYear()
  return (
    <Flex sx={{ backgroundColor: "coalBlackV2" }}>
      <Container
        // as='footer'
        sx={{
          mt: "32px",
          minHeight: "274px",
          py: "28px",
          // px:'40px !important',
          display: "flex",
          flexDirection: "column",
          maxWidth: "1200px",
        }}
      >
        <Flex
          sx={{
            marginBottom: "32px",
            flexDirection: ["column", "column", "row"],
            justifyContent: "space-between",
          }}
        >
          <Flex
            sx={{
              justifyContent: ["flex-start", "flex-start", "flex-start"],
              flex: 1,
            }}
            className="footer-logo"
          >
            <Box sx={{ maxWidth: "200px", marginBottom: ["50px"] }}>
              <Link to="/">
                <GatsbyImage image={footerNavLogo.gatsbyImageData} alt={footerNavLogo.description} />
              </Link>
            </Box>
          </Flex>

          <Flex
            sx={{
              justifyContent: "flex-end",
              // flex: [1, 1, 2, 1],
              maxWidth: ["100%", "50%"],
              maxHeight: ["300px", "100%"],
              flexDirection: ["column", "column", "row"],
              marginBottom: 4,
              // flexWrap:'wrap',
            }}
            className="footer-nav-group"
          >
            {footerNavGroups.map((group) => (
              <Flex
                key={group.id}
                sx={{
                  flexDirection: "column",
                  alignItems: "left",
                  justifyContent: "space-around",
                  width: ["150px", null, null, "200px"],
                }}
              >
                <Text
                  sx={{ color: "orangeV2", textAlign: "left", paddingLeft: "0", fontSize: "18px", fontWeight: 600 }}
                >
                  {group.footerNavGroupTitle}
                </Text>
                <FooterNavGroup navGroup={group} />
              </Flex>
            ))}
          </Flex>
        </Flex>

        <Flex
          sx={{
            justifyContent: "space-between",
            flexDirection: ["column", "column", "row"],
            margin: 0,
            paddingTop: 10,
            color: "#f8f8f8",
            borderTop: "0.5px solid #f8f8f830",
          }}
        >
          <span
            sx={{
              fontSize: "14px",
            }}
          >
            &#169;{year} Great Expectations. All Rights Reserved.
          </span>
          {/* <Link to="/privacy-policy"
          sx={{
            fontSize: '14px',
            textDecoration:'underline',
            color:'#f8f8f8',
            '&:hover':{
              color:'#FF6310'
            }
          }}
        >
          Privacy Policy </Link> */}
        </Flex>
      </Container>
    </Flex>
  )
}

export default Footer
